import { gateway } from "../../../../gateway";

export async function verifyTwoFaAction({ uid, activationToken, twoFaMethod, code }) {
  const response = await gateway.post("users/verify-validate-twofa", {
    uid,
    activationToken,
    twoFaMethod,
    code,
  }, { withCredentials: true });
  return response.data;
}
